var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div class="notify-qv-back" data-omtag="for_sale:ldp-nf-qv:sticky:qv_back">\n  <i class="ra ra-angle-left"></i>\n</div>\n\n<h4 class="notify-qv-title">\n  For You\n  <div class="notification-modal-qv-wrapper" id="notificationWrapper">\n    <span class="notification-count" id="notificationCount"></span>\n  </div>\n</h4>\n\n<a href="javascript:void(0)" class="qv-close pull-right" id="qv-ntfn-close" data-omtag="for_sale:ldp-nf-qv:sticky:close">\n  <i class="ra ra-close-thin"></i>\n</a>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-notify-property-header.jst.ejs